import * as actionTypes from "../actions/actionTypes";

const initialState = {
	loading: false,
	msgs: false,
};

// const msgDelete = (id) => {};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.MESSAGE_FETCHING:
			return {
				...state,
				loading: true,
			};
		case actionTypes.MESSAGE_FETCHING_SUCCESSFULLY:
			return {
				...state,
				msgs: action.msgs,
				loading: false,
			};
		case actionTypes.MESSAGE_DELETING:
			return {
				...state,
				loading: true,
			};
		case actionTypes.MESSAGE_DELETING_SUCCESSFULLY:
			// console.log(action.id);
			// console.log(state.msgs);
			const newMsgs = state.msgs.filter((m) => m.id !== action.id);
			// console.log(newMsgs);
			return {
				...state,
				msgs: newMsgs,
				loading: false,
			};
		default:
			return state;
	}
};

export default reducer;
